module.exports = __webpack_public_path__ + "img/sergeant-tips-icon5.ebb14e02.png";